var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":""},on:{"click":_vm.back}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-arrow-left-circle-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }